import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { supportTicketRelated } from "@mainaction";
import FourZeroFour from "../../common/pagenotfound";
import Loader from "@loader";
import LocaleStrings from "@language";

const SupportTicketThankYou = (props) => {
  let { session } = props;
  const [isInvalidURL, setIsInvalidURL] = useState(false);
  const [isAlreadySubmitted, setisAlreadySubmitted] = useState(false);
  const [showThankyou, setshowThankyou] = useState(false);
  const [showLoader, setshowLoader] = useState(true);

  useEffect(() => {
    // Function to parse URL parameters
    const getUrlParams = (url) => {
      const params = {};
      const urlParams = new URLSearchParams(url.slice(url.indexOf("?") + 1));
      for (const [key, value] of urlParams) {
        params[key] = value;
      }
      return params;
    };
    // Get current URL
    const currentUrl = window.location.href;
    // Parse URL parameters
    const params = getUrlParams(currentUrl);

    // Extract id and case from parameters
    const { id, case: caseValue } = params;

    if (id !== "" && caseValue !== "") {
      let obj1 = {
        id: id,
      };
      let obj2 = {
        id: id,
        case: caseValue,
      };

      props.supportTicketRelated(session, obj1, (callback) => {
        if (callback.success === 1) {
          props.supportTicketRelated(session, obj2, (callback) => {});
          setshowThankyou(true);
          setshowLoader(false);
        } else {
          setshowLoader(false);
          setisAlreadySubmitted(true);
        }
      });
    } else {
      setshowLoader(false);
      setIsInvalidURL(true);
    }

    // Add dependencies as necessary
  }, []);

  return (
    <>
      {isInvalidURL ? (
        <>
          <FourZeroFour />
        </>
      ) : (
        <>
          {!showLoader ? (
            <>
              {showThankyou ? (
                <div className="mt-60 mx-20">
                  <div className="rounded-md border border-green-300 bg-green-50 p-4">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <CheckCircleIcon
                          className="h-6 w-6 text-green-400"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="ml-3">
                        <div className="text-md font-semibold text-green-700">
                          {LocaleStrings.kThankYouSupportTicketSubmit}
                        </div>
                      </div>
                      <div className="ml-auto pl-3">
                        <div className="-mx-1.5 -my-1.5"></div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : isAlreadySubmitted ? (
                <div className="mt-60  mx-48">
                  <div className="rounded-md border border-red-300 bg-red-50 p-4">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <CheckCircleIcon
                          className="h-6 w-6 text-red-400"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="ml-3">
                        <div className="text-md font-semibold text-red-700">
                          {
                            LocaleStrings.kThankYousupportTicketErrorResubmission
                          }
                        </div>
                      </div>
                      <div className="ml-auto pl-3">
                        <div className="-mx-1.5 -my-1.5"></div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            <Loader />
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ supportTicketRelated }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportTicketThankYou);
